import dayjs from "../../utils/dayjs";
import TimeSlotting, { toTimeDuration } from "./timeSlotting";
const timeSlotting = new TimeSlotting();
function reconcileDateChange(target, next) {
  const date = dayjs(next);
  return dayjs(target).year(date.year()).month(date.month()).date(date.date()).toString();
}
function reconcileTimeChange(target, timeString) {
  const [hours, minutes] = timeString.split(":").map((v) => parseInt(v, 10));
  return dayjs(target).hour(hours).minute(minutes).toString();
}
function reconcileTimeSlot(target, slot) {
  return dayjs(target).add(slot.days(), "days").hour(slot.hours()).minute(slot.minutes()).toString();
}
function getRestrainedOutboundTime(outboundTime) {
  const outboundDate = dayjs(outboundTime);
  const slot = outboundDate.isSameOrBefore(void 0, "minutes") ? timeSlotting.findClosestLeftOrSame(dayjs()) : timeSlotting.findClosestLeftOrSame(outboundDate);
  return reconcileTimeSlot(outboundDate, slot);
}
function getRestrainedInboundTime(outboundTime, inboundTime) {
  const inboundDate = dayjs(inboundTime);
  if (inboundDate.isSameOrBefore(outboundTime, "minutes")) {
    const slot2 = timeSlotting.findClosestRight(outboundTime);
    return reconcileTimeSlot(outboundTime, slot2);
  }
  if (inboundDate.isSame(outboundTime, "date")) {
    const inboundSlot = timeSlotting.findClosestLeftOrSame(inboundTime);
    const outboundSlot = timeSlotting.findClosestRight(outboundTime);
    const slot2 = inboundSlot.asMinutes() < outboundSlot.asMinutes() ? outboundSlot : inboundSlot;
    return reconcileTimeSlot(inboundTime, slot2);
  }
  const slot = timeSlotting.findClosestLeftOrSame(inboundTime);
  return reconcileTimeSlot(inboundTime, slot);
}
function getInitialInboundTime(outboundTime) {
  const slot = timeSlotting.findClosestRight(outboundTime).add({ hours: 1 });
  return reconcileTimeSlot(outboundTime, slot);
}
function getOutboundTimeOptions(outboundTime, step, minuteIntervalsEnabled = true) {
  timeSlotting.setStep(step ? dayjs.duration({ hours: step }) : void 0);
  timeSlotting.setMinuteIntervalsEnabled(minuteIntervalsEnabled);
  const slot = dayjs(outboundTime).isToday() ? timeSlotting.findClosestLeft(dayjs(), true) : dayjs.duration(0).clone();
  return {
    hour: timeSlotting.createHourOptions(slot),
    minutes: timeSlotting.createMinuteOptions(toTimeDuration(outboundTime).hours() <= slot.hours() ? slot : void 0)
  };
}
function getInboundTimeOptions(outboundTime, inboundTime, step, minuteIntervalsEnabled = true) {
  timeSlotting.setMinuteIntervalsEnabled(minuteIntervalsEnabled);
  if (!inboundTime) {
    return {
      hour: timeSlotting.createHourOptions(dayjs.duration({ days: 1 })),
      minutes: timeSlotting.createMinuteOptions()
    };
  }
  timeSlotting.setStep(step ? dayjs.duration({ hours: step }) : void 0);
  const slot = dayjs(inboundTime).isSameOrBefore(outboundTime, "date") ? timeSlotting.findClosestRight(outboundTime) : dayjs.duration(0).clone();
  return {
    hour: timeSlotting.createHourOptions(slot),
    minutes: timeSlotting.createMinuteOptions(toTimeDuration(inboundTime).hours() <= slot.hours() ? slot : void 0)
  };
}
export {
  getInboundTimeOptions,
  getInitialInboundTime,
  getOutboundTimeOptions,
  getRestrainedInboundTime,
  getRestrainedOutboundTime,
  reconcileDateChange,
  reconcileTimeChange,
  reconcileTimeSlot
};
